module.exports = __webpack_public_path__ + "static/media/Penny Yu.22bbc5ce.png";